/**
 * Cross-browser Fullscreen API helpers.
 */

export function getFullscreenElement() {
  const d = document;
  return (
    d.fullscreenElement ??
    d.webkitFullscreenElement ??
    d.mozFullScreenElement ??
    d.msFullscreenElement ??
    null
  );
}

export function isElementFullscreen(element) {
  if (!element) return false;
  return getFullscreenElement() === element;
}

export function isDocumentFullscreen() {
  return !!getFullscreenElement();
}

export function requestFullscreen(element) {
  if (!element) return Promise.resolve();
  const el = element;
  let p = null;
  if (el.requestFullscreen) p = el.requestFullscreen();
  else if (el.webkitRequestFullscreen) p = el.webkitRequestFullscreen();
  else if (el.mozRequestFullScreen) p = el.mozRequestFullScreen();
  else if (el.msRequestFullscreen) p = el.msRequestFullscreen();
  if (p && typeof p.catch === 'function') {
    return p.catch(() => {});
  }
  return Promise.resolve();
}

export function exitFullscreen() {
  const d = document;
  let p = null;
  if (d.exitFullscreen) p = d.exitFullscreen();
  else if (d.webkitExitFullscreen) p = d.webkitExitFullscreen();
  else if (d.mozCancelFullScreen) p = d.mozCancelFullScreen();
  else if (d.msExitFullscreen) p = d.msExitFullscreen();
  if (p && typeof p.catch === 'function') {
    return p.catch(() => {});
  }
  return Promise.resolve();
}
